<div class="container">
  <div class="row footer-top py-4">
    <!-- <div class="col-md-3 pb-3">
      <h5 class="footer-header">{{ "Headquarters" | translate }}</h5>
      <p class="footer-title">Kenneth Hahn</p>
      <p class="footer-title">Hall of Administration</p>
      <p>500 W. Temple Street, Room 225</p>
      <p>Los Angeles, CA 90012</p>
      <p>(213) 974-3211</p>
      <p class="font-italic">Toll Free Phone:</p>
      <p>1 (888) 807-2111</p>
    </div> -->
    <div id="border-item" class="col-md-9 border-end pl-md-4">
      <h5 class="footer-header">{{ "Office Locations" | translate }}</h5>
      <div class="row footer-top district-offices">

        <div class="district-office">
      <!-- <h5 class="footer-header">{{ "Headquarters" | translate }}</h5> -->
      <p class="footer-title">Headquarters-Downtown LA</p>
      <!-- <p class="footer-title">Hall of Administration</p> -->
      <p>500 W. Temple Street, Room 225</p>
      <p>Los Angeles, CA 90012</p>
      <p>(213) 974-3211</p>
      <p class="font-italic">Toll Free Phone:</p>
      <p>1 (888) 807-2111</p>
    </div>

        <div class="district-office">
          <p class="footer-title">Sylmar (Closed)</p>
          <!-- <p>Public services are temporarily moved to the Hall of Administration, Room 225.</p> -->
          <p [innerHTML]="'Footer.Temporary'|translate"></p>
          <p><i>Room 293 (Mailing Address)</i></p>
          <p>(818) 833-6000</p>
        </div>

        <div class="district-office">
          <p class="footer-title">South El Monte</p>
          <p>1190 Durfee Avenue</p>
          <p>South El Monte, CA 91733</p>
          <p>(626) 258-6001</p>
        </div>
        <div class="district-office">
          <p class="footer-title">Beverly Hills</p>
          <p>9355 Burton Way, Suite 400</p>
          <p>Beverly Hills, CA 90210</p>
          <p>(310) 665-5300</p>
        </div>

        <div class="district-office">
          <p class="footer-title ">Signal Hill</p>
          <p>1401 E. Willow Street</p>
          <p>Signal Hill, CA 90755</p>
          <p>(562) 256-1701</p>
        </div>
        <div class="district-office">
          <p class="footer-title">Culver City</p>
          <!-- <p>Public services are temporarily moved to the Hall of Administration, Room 225. <i>Room 183-19 (mailing address)</i></p> -->
          <p>6167 Bristol Parkway, <br>Suite 100</p>
          <p>Culver City, CA 90230</p>
          <p>(310) 665-5300</p>

        </div>
        <div class="district-office">
          <p class="footer-title">Lancaster Regional</p>
          <p>251 E. Avenue K-6</p>
          <p>Lancaster, CA 93535</p>
          <p>(661) 940-6700</p>
        </div>
        <div class="district-office">
          <p class="footer-title">Castaic Library</p>
          <p>27971 Sloan Canyon Road</p>
          <p>Castaic, CA 91384</p>
          <p>(818) 833-6300</p>
        </div>
      </div>
    </div>

    <div class="col-md-3 px-md-4 pl-md-4">
      <h5 class="footer-header socials-header">{{ "Home.Connected" | translate }}</h5>
      <div class="row pl-2">
        <span class="footer-social"><a href="https://www.facebook.com/LACAssessor/" title="Facebook" target="_blank"><i
        class="fab fa-facebook-square"></i></a></span>
        <span class="footer-social"><a href="https://x.com/lacassessor" title="X" target="_blank"><i
        class="fa-brands fa-x-twitter"></i></a></span>
        <span class="footer-social"><a href="https://www.instagram.com/lacassessor/" title="Instagram" target="_blank"><i
        class="fab fa-instagram"></i></a></span>
        <span class="footer-social"><a href="https://www.youtube.com/channel/UCEiJxk8Zh_ETjmzFp_eYdVQ" title="Youtube"
          target="_blank"><i class="fab fa-youtube"></i></a></span>
        </div>
        <div class="row pl-2 pl-md-3 mt-3">
          <button type="button" aria-label="Newsletter sign up" routerLink="/news-information/newsletters"
            class="footer-btn btn btn-light">{{ "Home.NewsLetter" | translate }} <span><i
          class="fas fa-angle-right"></i></span></button>
        </div>
        <div class="row pl-2 pl-md-3 mt-3">
          <a type="button" aria-label="County Job Opportunities"style="-webkit-appearance: none; border-radius: 0;" target="_blank"
            href="https://www.governmentjobs.com/careers/lacounty"
            class="footer-btn btn btn-light">{{ "NavMenu.CountyJob" | translate }}<span><i
          class="fas fa-angle-right"></i></span></a>
        </div>
          <div class="row pl-2 pl-md-3 mt-3">
            <a routerLink="/accessibility-statement" aria-label="Accessibility"
              class="footer-btn btn btn-light">
              {{ "Footer.Accessibility" | translate }}
              <span><i class="fas fa-angle-right"></i></span>
            </a>
          </div>
      </div>
    </div>
</div>

<div class="row bottom-footer">
  <p>
    <span><i class="far fa-copyright"></i></span>
    los angeles county assessor's office. {{ date }}. |
    <a id="changelog" [routerLink]="['/changelog']" style="text-transform: lowercase;">
      {{ latestVersion || 'loading...' }}
    </a>
    @if (latestDate) {
      <span>(Last updated {{ latestDate }})</span>
    }
    | SSO
  </p>
</div>
